import { render, staticRenderFns } from "./InsectTypePieChart.vue?vue&type=template&id=08de5304&scoped=true&"
import script from "./InsectTypePieChart.vue?vue&type=script&lang=js&"
export * from "./InsectTypePieChart.vue?vue&type=script&lang=js&"
import style0 from "./InsectTypePieChart.vue?vue&type=style&index=0&id=08de5304&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de5304",
  null
  
)

/* custom blocks */
import block0 from "./InsectTypePieChart.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08de5304')) {
      api.createRecord('08de5304', component.options)
    } else {
      api.reload('08de5304', component.options)
    }
    module.hot.accept("./InsectTypePieChart.vue?vue&type=template&id=08de5304&scoped=true&", function () {
      api.rerender('08de5304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/Top5InsectsPanel/InsectTypePieChart.vue"
export default component.exports